module.exports = __webpack_public_path__ + "static/media/01.9e70e3ea.svg";